import emailjs from "@emailjs/browser";

const SERVICE = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// Sends an alert when a vendor registers. Recipient is set in the EmailJS
// template's "To" field (keeps your address out of the client bundle).
// Safe to call even if not configured — it just no-ops.
export async function sendNewVendorAlert(vendor) {
  if (!SERVICE || !TEMPLATE || !PUBLIC_KEY) return;
  const params = {
    business_name: vendor.businessName,
    category: vendor.category,
    account_type: vendor.accountType,
    city: vendor.city,
    price: vendor.priceRange,
    phone: vendor.phone,
    whatsapp: vendor.whatsapp || "—",
    instagram: vendor.instagram || "—",
    description: vendor.description || "—",
    admin_link: `${window.location.origin}/admin`,
  };
  await emailjs.send(SERVICE, TEMPLATE, params, { publicKey: PUBLIC_KEY });
}

const BOOST_TEMPLATE = process.env.REACT_APP_EMAILJS_BOOST_TEMPLATE_ID;

// Alerts you when a vendor requests a boost. Uses a separate template if set,
// otherwise falls back to the main one. No-ops if EmailJS isn't configured.
export async function sendBoostAlert(vendor, days, price) {
  const template = BOOST_TEMPLATE || TEMPLATE;
  if (!SERVICE || !template || !PUBLIC_KEY) return;
  const params = {
    business_name: vendor.businessName,
    boost_days: days,
    boost_price: `€${price}`,
    admin_link: `${window.location.origin}/admin`,
  };
  await emailjs.send(SERVICE, template, params, { publicKey: PUBLIC_KEY });
}
